import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "../.themes";

export const useStyles = makeStyles<Theme>((theme: Theme) => ({
  ComponentWrapper: {
    width: `100%`,
    "& .MuiPaper-root": {
      backgroundColor: theme.coverageSelect?.descriptionCard?.backgroundColor ?? theme.palette.background.paper,
    },
  },
  TableWrapper: {
    overflowX: "hidden",
    overflowY: "hidden",
    whiteSpace: "nowrap",
    // display: 'table',
    position: "relative",
    margin: "0 auto",
    textAlign: "center",
  },
  RecommendedCoverageDescriptionHeader: {
    color: theme.coverageSelect?.descriptionCard?.textColor,
    fontFamily: theme.coverageSelect?.descriptionCard?.fontFamily,
    Variant: "h2",
    lineHeight: "40px",
    paddingBottom: "24px",
  },
  SingleRecommendation: {
    textAlign: "center",
  },
  SingleRecommendedColumn: {
    display: "inline-block",
    textAlign: "left",
    backgroundColor: theme.coverageSelect?.root?.backgroundColor ?? theme.palette.common.white,
    position: "relative",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "384px",
    },
    "& $CoverageItemRow": {
      justifyContent: "left",
      [theme.breakpoints.up("sm")]: {
        paddingLeft: "10%",
      },
      flexBasis: "35%",
      flexGrow: "2",
      "&:nth-child(4n), &:nth-child(4n-1)": {
        backgroundColor: theme.palette.background.default,
        ...theme?.coverageSelect?.singleRecommended?.secondLineColor,
      },
      "&:nth-child(4n-2), &:nth-child(4n-3)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
    "& $CoverageItemList": {
      display: "flex",
      flexWrap: "wrap",
    },
    "& $CoverageColumn": {
      backgroundColor: theme.coverageSelect?.selected?.backgroundColor ?? theme.palette.divider,
      border: `${theme.border} ${theme.coverageSelect?.selected?.borderColor ?? theme.palette.primary.main}`,
      borderTopWidth: "2px",
      borderBottomRightRadius: theme.shape.borderRadius,
      borderBottomLeftRadius: theme.shape.borderRadius,
      paddingBottom: theme.spacing(3),
    },
    "& $CoverageRecommended": {
      backgroundColor: theme.coverageSelect?.recommended?.backgroundColor ?? theme.palette.primary.main,
      color: theme.coverageSelect?.recommended?.textColor ?? theme.palette.primary.contrastText,
      border: `${theme.border} ${theme.coverageSelect?.recommended?.borderColor ?? theme.palette.primary.main}`,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      minHeight: "10px",
    },
    "& $CoverageHeaderName": {
      marginLeft: "0px",
      fontWeight: theme.coverageSelect?.selected?.CoverageHeaderName?.fontWeight ?? "bold",
      fontFamily: theme.coverageSelect?.selected?.CoverageHeaderName?.fontFamily ?? theme.typography.fontFamily,
      color: theme.coverageSelect?.selected?.CoverageHeaderName?.color,
    },
    "& $CoverageHeaderPrice": {
      fontWeight: theme.coverageSelect?.selected?.CoverageHeaderPrice?.fontWeight ?? "bold",
      color: theme.coverageSelect?.selected?.CoverageHeaderPrice?.color,
      fontFamily: theme.coverageSelect?.selected?.CoverageHeaderPrice?.fontFamily ?? theme.typography.fontFamily,
    },
    "& $CoverageItemText": {
      "&.withDescription": {
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
  },
  CoverageColumnWrapper: {
    display: "inline-block",
    textAlign: "left",
    backgroundColor: theme.coverageSelect?.root?.backgroundColor ?? theme.palette.common.white,
    position: "relative",
    width: "24.5%",
    [theme.breakpoints.up("md")]: {
      width: "33%",
    },
    "& $CoverageItemRow": {
      padding: "none",
      "&:first-child": {
        borderTop: "none",
      },
      borderBottom: "none",
    },
    ...theme.coverageSelect?.root?.CoverageWrapper,
    "&.selected": {
      borderRadius: theme.shape.borderRadius,
      width: theme.coverageSelect?.selected?.mobileCoverageSelectedWith ?? "50%",
      [theme.breakpoints.up("md")]: {
        width: "33.3%",
      },
      "& $CoverageItemRow": {
        justifyContent: "start",
        [theme.breakpoints.up("md")]: {
          paddingLeft: "20%",
        },
        ...theme.coverageSelect?.selected?.CoverageItem,
      },
      "& $CoverageColumn": {
        backgroundColor: theme.coverageSelect?.selected?.backgroundColor ?? theme.palette.divider,
        border: `${theme.border} ${theme.coverageSelect?.selected?.borderColor ?? theme.palette.primary.main}`,
        borderWidth: theme.coverageSelect?.selected?.borderWidth ?? theme.border,
        borderTopWidth: "2px",
        borderBottomRightRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,
        paddingBottom: theme.coverageSelect?.selected?.paddingBottom ?? theme.spacing(3),
      },
      "& $CoverageRecommended": {
        backgroundColor: theme.coverageSelect?.recommended?.backgroundColor ?? theme.palette.primary.main,
        color: theme.coverageSelect?.recommended?.textColor ?? theme.palette.primary.contrastText,
        border: `${theme.border} ${theme.coverageSelect?.recommended?.borderColor ?? theme.palette.primary.main}`,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        minHeight: "10px",
      },
      "& $CoverageHeaderName": {
        fontWeight: theme.coverageSelect?.selected?.CoverageHeaderName?.fontWeight ?? "bold",
        fontFamily: theme.coverageSelect?.selected?.CoverageHeaderName?.fontFamily ?? theme.typography.fontFamily,
        color: theme.coverageSelect?.selected?.CoverageHeaderName?.color,
      },
      "& $CoverageHeaderPrice": {
        fontWeight: theme.coverageSelect?.selected?.CoverageHeaderPrice?.fontWeight ?? "bold",
        color: theme.coverageSelect?.selected?.CoverageHeaderPrice?.color,
        fontFamily: theme.coverageSelect?.selected?.CoverageHeaderPrice?.fontFamily ?? theme.typography.fontFamily,
      },
      "& $CoverageItemText": {
        "&.withDescription": {
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
    },
    "&:not(.selected)": {
      "& $CoverageItemRow": {
        textAlign: "center",
      },
      "& + $CoverageColumnWrapper:not(.selected)": {
        borderLeft: `${theme.border} ${theme.coverageSelect?.root?.borderColor ?? theme.palette.grey[400]}`,
      },
    },
    "&:first-of-type": {
      "&:not(.selected)": {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,
        "& $CoverageColumn": {
          borderTopLeftRadius: theme.shape.borderRadius,
          borderBottomLeftRadius: theme.shape.borderRadius,
        },
      },
    },
    "&:last-of-type": {
      "&:not(.selected)": {
        borderTopRightRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        "& $CoverageColumn": {
          borderTopRightRadius: theme.shape.borderRadius,
          borderBottomRightRadius: theme.shape.borderRadius,
        },
      },
    },
    "&:not(:first-of-type)": {
      "& $CoverageColumn": {
        borderLeft: 0,
      },
    },
    "&:not(:last-of-type)": {
      "& $CoverageColumn": {
        borderRight: 0,
      },
    },
  },
  CoverageColumn: {
    border: `${theme.border} ${theme.coverageSelect?.root?.borderColor ?? theme.palette.grey[400]}`,
  },
  CoverageRecommended: {
    textAlign: "center",
    fontSize: "0.75rem",
    fontWeight: 700,
  },
  CoverageHeader: {
    textAlign: "center",
    padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
    borderBottom: `${theme.border} ${theme.coverageSelect?.root?.borderColor ?? theme.palette.grey[400]}`,
    "&:hover": {
      cursor: "pointer",
    },
  },
  CoverageHeaderName: {
    fontFamily: theme.coverageSelect?.root?.CoverageHeaderName?.fontFamily ?? theme.typography.fontFamily,
    color: theme.coverageSelect?.root?.CoverageHeaderName?.color ?? theme.palette.text.primary,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    fontWeight: theme.coverageSelect?.root?.CoverageHeaderName?.fontWeight ?? "normal",
    display: "block",
  },
  CoverageHeaderPrice: {
    fontFamily: theme.coverageSelect?.root?.CoverageHeaderPrice?.fontFamily ?? theme.typography.fontFamily,
    color: theme.coverageSelect?.root?.CoverageHeaderPrice?.color ?? theme.palette.text.primary,
    fontSize: "1rem",
    fontWeight: theme.coverageSelect?.root?.CoverageHeaderPrice?.fontWeight ?? "normal",
    display: "block",
  },
  CoverageItemList: {
    margin: 0,
    padding: theme.coverageSelect?.root?.CoverageItemList?.padding ?? `${theme.spacing(1.5)}px 0`,
    listStyleType: "none",
  },
  CoverageItemRow: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.text.primary,
    lineHeight: theme.typography.body1.lineHeight,
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(1),
    "&:nth-child(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  CoverageItemIcon: {
    verticalAlign: "sub",
    color: theme.coverageSelect?.root?.textColor ?? theme.palette.text.hint,
    margin: `0 ${theme.spacing(1)}px`,
    "&.included": {
      color: theme.coverageSelect?.selected?.textColor ?? theme.palette.primary.main,
    },
  },
  CoverageItemText: {
    "&.withDescription": {
      textDecoration: "underline",
      fontWeight: 400,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    color: theme.coverageSelect?.root?.CoverageItemText?.color,
  },
  SelfRiskWrapper: {
    maxWidth: theme.containerMaxWidth,
    width: "100%",
    margin: theme.centred ?? `${theme.spacing(2)}px 0`,
    marginTop: theme.spacing(2),
  },
}));
